<section class="delivery-instructions" aria-labelledby="delivery-instructions-heading">
  <puro-typography
    id="delivery-instructions-heading"
    class="delivery-instructions__title"
    variant="h5-semibold"
    component="h3"
  >
    {{ 'createShipment.packageStep.deliveryInstructions.title' | translate }}
  </puro-typography>

  @if (hasRestrictedCharactersError()) {
    <app-alert-toast
      class="delivery-instructions__error"
      severity="error"
      live="assertive"
      [message]="
        'createShipment.packageStep.deliveryInstructions.restrictedCharactersError' | translate
      "
    />
  }

  <puro-input
    class="delivery-instructions__input"
    [formControl]="control()"
    [maxLength]="maxLength"
    [error]="hasFieldError()"
    [label]="'createShipment.packageStep.deliveryInstructions.fieldLabel' | translate"
    (focusout)="onFieldBlur()"
  />
</section>
